export const companyPhoneDefaultValues = (
    defaultValues: MyBrokerApi.TelephoneNumber = {},
): MyBrokerApi.TelephoneNumberForm => {
    const { number, type, description } = defaultValues;
    return {
        number: number || "",
        type: type?.id || "",
        description: description || "",
    };
};

export const companyPhoneFixture = (): MyBrokerApi.TelephoneNumberForm => ({
    number: "+32 0480 00 00 00",
    type: "007",
    description: "That's my phone number",
});

export const companyEmailDefaultValues = (
    defaultValues: MyBrokerApi.EmailAddress = {},
): MyBrokerApi.EmailAddressForm => {
    const { email, description } = defaultValues;
    return {
        email: email || "",
        description: description?.name || "",
    };
};

export const companyEmailFixture = (): MyBrokerApi.EmailAddressForm => ({
    email: "cool@email.com",
    // Add select with freeSolo option on jest to test this
    description: "",
});

export const companyContactDefaultValues = (
    defaultValues: MyBrokerApi.MoralContact = {},
): MyBrokerApi.MoralContactForm => {
    const { telephoneNumbers, emailAddresses } = defaultValues;
    return {
        telephoneNumbers: (telephoneNumbers?.length ? telephoneNumbers : [{}]).map(companyPhoneDefaultValues),
        emailAddresses: (emailAddresses?.length ? emailAddresses : [{}]).map(companyEmailDefaultValues),
    };
};

export const companyContactFixture = (): MyBrokerApi.MoralContactForm => ({
    telephoneNumbers: [companyPhoneFixture()],
    emailAddresses: [companyEmailFixture()],
});
